import { render, staticRenderFns } from "./property-settings-page.vue?vue&type=template&id=3602de89&"
import script from "./property-settings-page.vue?vue&type=script&lang=js&"
export * from "./property-settings-page.vue?vue&type=script&lang=js&"
import style0 from "./property-settings-page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports